// extracted by mini-css-extract-plugin
export default {"container":"Prices_container__cIOqK","content":"Prices_content__G3PYm"};